import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        Kas Dekker
      </header>
    </div>
  );
}

export default App;
